<template lang="html">
  <div class="list-card-observatory">
    <Carousel :settings="settings" :breakpoints="breakpoints">
      <Slide v-for="(item, idx) in data" :key="idx">
        <CardObservatory
          :imageURL="baseUrlStorage+item.background"
          :title="item.title"
          :description="item.description"
          :id="item.id"
          buttonText="VER MÁS"
        />
      </Slide>
      <template #addons>
        <Navigation />
      </template>
    </Carousel>
  </div>
</template>
<script>
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Navigation } from "vue3-carousel";

import CardObservatory from "./CardObservatory.vue";

export default {
  props: ["data"],
  inject: ['baseUrlStorage'],
  components: {
    Carousel,
    Slide,
    Navigation,
    CardObservatory,
  },
  data: () => ({
    // carousel settings
    observatories: [
      {
        imageURL: "https://i.ibb.co/JH4gKwY/Card-Category-Info1.png",
        title: "Lorem ipsum dolor sit amet",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Senectus enim luctus",
        buttonText: "VER más",
      },
      {
        imageURL: "https://i.ibb.co/JH4gKwY/Card-Category-Info1.png",
        title: "Lorem ipsum dolor sit amet",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Senectus enim luctus",
        buttonText: "VER más",
      },
      {
        imageURL: "https://i.ibb.co/JH4gKwY/Card-Category-Info1.png",
        title: "Lorem ipsum dolor sit amet",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Senectus enim luctus",
        buttonText: "VER más",
      },
      {
        imageURL: "https://i.ibb.co/JH4gKwY/Card-Category-Info1.png",
        title: "Lorem ipsum dolor sit amet",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Senectus enim luctus",
        buttonText: "VER más",
      },
      {
        imageURL: "https://i.ibb.co/JH4gKwY/Card-Category-Info1.png",
        title: "Lorem ipsum dolor sit amet",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Senectus enim luctus",
        buttonText: "VER más",
      },
    ],
    settings: {
      itemsToShow: 1,
      snapAlign: "start",
    },
    // breakpoints are mobile first
    // any settings not specified will fallback to the carousel settings
    breakpoints: {
      // 700px and up
      0: {
        itemsToShow: 1,
      },
      700: {
        itemsToShow: 2,
      },
      1000: {
        itemsToShow: 3,
        snapAlign: "start",
      },
      // 1024 and up
      1400: {
        itemsToShow: 4,
        snapAlign: "start",
      },
    },
  }),
};
</script>
<style lang="css">
.list-card-observatory .carousel__slide {
  display: flex;
  align-items: flex-start;
}
.list-card-observatory .carousel__track {
  gap: 0;
}
.list-card-observatory .carousel__prev--in-active,
.list-card-observatory .carousel__next--in-active {
  display: none;
}
.list-card-observatory .carousel__prev,
.list-card-observatory .carousel__next {
  background: transparent;
  top: 30%;
}
.list-card-observatory .carousel__next {
  right: 4px;
}
.list-card-observatory .carousel__viewport {
  border-radius: 10px;
}
</style>


carousel__slide carousel__slide--active carousel__slide--visible